<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="row">
                <div class="col-xl-12">
                    <div class="row">
                        <div class="col-xl-6">
                            <h6 class="mb-1">
                                <i v-if="icon" :class="icon" class="mr-1"></i>
                                {{ title }}
                            </h6>
                            <p class="hint mb-3">{{ hint }}</p>
                            <fg-input
                                v-model="searchQuery"
                                :placeholder="searchPlaceholder || 'Search'"
                                class="input-sm"
                                addon-right-icon="nc-icon nc-zoom-split"
                            />
                            <p v-if="filters && !matchEvery" class="hint mb-1">
                                Results that match at least one of these selected filters will be displayed.
                            </p>
                            <p v-if="filters && matchEvery" class="hint mb-1">
                                Results that match each selected filter will be displayed.
                            </p>
                            <el-select
                                v-if="filters"
                                ref="filters"
                                v-model="tablefilters"
                                value-key="propKey"
                                class="w-100"
                                multiple
                                name="filters"
                                placeholder="Select Filters(s)"
                                @change="blur"
                            >
                                <el-option
                                    v-for="filter in filters"
                                    :key="filter.propValue"
                                    :label="filter.label"
                                    :value="filter.value"
                                    :disabled="filter.disabled"
                                    class="select-primary"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="col-xl-6">
                            <div class="pull-right text-right">
                                <p class="hint mb-2">Results per page</p>
                                <el-select v-model="pagination.perPage" size="mini" class="select-default w-50" placeholder="Per page">
                                    <el-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item" class="select-default" />
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 my-3">
                    <slot :data="pagedData" name="table" />
                </div>
                <div class="col-sm-6 pagination-info">
                    <p class="hint">Showing {{ pagedData.length > 0 ? from + 1 : 0 }} to {{ to }} of {{ queriedData.length }}</p>
                </div>
                <div class="col-sm-6">
                    <p-pagination v-model="pagination.currentPage" :per-page="pagination.perPage" :total="pagination.total" class="pull-right"> </p-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ENTRIES } from 'db'
export default {
    props: {
        data: {
            type: [Array, Boolean],
            required: true
        },
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            default: ''
        },
        hint: {
            type: String,
            default: ''
        },
        propsToSearch: {
            type: Array,
            required: true
        },
        searchPlaceholder: {
            type: String,
            default: ''
        },
        filters: {
            type: [Array, Boolean],
            default: false
        },
        matchEvery: {
            type: Boolean,
            default: false
        },
        hasCreatedAtSort: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: this.data.length
            },
            tablefilters: [],
            searchQuery: ''
        }
    },
    computed: {
        filteredData() {
            return this.tablefilters.length > 0
                ? this.data.filter((item) => {
                      return this.matchEvery
                          ? this.tablefilters.every((filter) => item[filter.propToFilter] === filter.propValue)
                          : this.tablefilters.some((filter) => item[filter.propToFilter] === filter.propValue)
                  })
                : this.data
        },
        pagedData() {
            return this.queriedData.slice(this.from, this.to)
        },
        queriedData() {
            return this.filteredData
                .slice()
                .sort((a, b) => {
                    if (this.hasCreatedAtSort === 'ASC') {
                        return a[ENTRIES.fields.createdAt] - b[ENTRIES.fields.createdAt]
                    } else {
                        return b[ENTRIES.fields.createdAt] - a[ENTRIES.fields.createdAt]
                    }
                })
                .filter((row) => {
                    let isIncluded = false
                    for (let key of this.propsToSearch || []) {
                        let filter
                        if (Array.isArray(key)) {
                            filter = key.reduce((acc, el) => {
                                if (acc[el]) {
                                    acc = acc[el]
                                }
                                return acc
                            }, row)
                        } else {
                            filter = row[key]
                        }
                        if (filter) {
                            const rowValue = filter.toString()
                            if (rowValue.includes && rowValue.toLowerCase().includes(this.searchQuery.toLowerCase())) {
                                isIncluded = true
                            }
                        }
                    }
                    return isIncluded
                })
        },
        to() {
            let highBound = this.from + this.pagination.perPage
            if (this.queriedData.length < highBound) {
                highBound = this.queriedData.length
            }
            return highBound
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total() {
            return this.data.length
        }
    },
    watch: {
        queriedData(val) {
            this.pagination.total = val.length
        }
    },
    methods: {
        blur() {
            this.$refs.filters.blur()
        }
    }
}
</script>

<style scoped></style>
